import PropTypes from 'prop-types';
import LoopingTextBanner from 'components/content-components/LoopingTextBanner';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';

const LoopingTextBannerDataTransformerBlock = ({ content = {} }) => {
    const { _editable, anchorTag = [], label = '' } = content;

    return <LoopingTextBanner id={transformAnchorTag({ anchorTag })} sbEditable={transformPreviewEditable(_editable)} text={label} />;
};

LoopingTextBannerDataTransformerBlock.propTypes = {
    content: PropTypes.object.isRequired,
};

export default LoopingTextBannerDataTransformerBlock;
